const StatusFieldValues = {
  Complete: "Complete",
  Approved: "Approved",
  InApproval: "In Approval",
  Intake: "Intake",
  Active: "Active",
  Cancel: "Cancel",
};

export default StatusFieldValues;
